import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, Textinput, Flex } from '../../../ui';

const AddDiscussionModal = ({ open, onClose, onSubmit }) => {
  const { t } = useTranslation();
  const [name, setName] = useState('');

  const handleAccept = async () => {
    await onSubmit({ name });
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={t('classroom.addDiscussion', 'Add Discussion')}
      width='440px'
      showActions
      onAccept={handleAccept}
      acceptLabel={t('globals.add', 'Add')}
      acceptIsDisabled={!name.trim()}
    >
      <Flex direction='column' gap='16'>
        <Textinput
          label={t('classroom.discussionTopic', 'Topic Name')}
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder='e.g. Group Project Discussion'
        />
      </Flex>
    </Modal>
  );
};

export default AddDiscussionModal;
